import {createApp} from 'vue'
import StafetRoundCounterAccordion from './StafetRoundCounterAccordion'

const el = '.kb-component--stafet-round-counter-accordion'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetRoundCounterAccordionDOM)=>{

            const  participantData = StafetRoundCounterAccordionDOM.dataset.data
            ? JSON.parse(StafetRoundCounterAccordionDOM.dataset.data)
            : null
            
            const maxRegistrationCount = StafetRoundCounterAccordionDOM.dataset.maxRegistrationCount

            const component = createApp(StafetRoundCounterAccordion, {participantData, maxRegistrationCount}).use(Store)
            component.mount(StafetRoundCounterAccordionDOM)
        })
    }
}